const pageTitle = ref("")

const setPageTitle = (newTitle: string) => {
  pageTitle.value = newTitle
}

export const usePageTitle = () => {
  return {
    pageTitle: readonly(pageTitle),
    setPageTitle,
  }
}
